// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.svg-container {
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    height: 100%;
}
.svg-container svg {
    position: relative;
    display: block;
}
.network-view-container {
    display: block;
    height: 100%;
    background-color: white;
    position: relative;
}

.node {
    stroke: #000;
    stroke-width: 1px;
}

.node.selected {
    stroke: #ed7225!important;
    stroke-opacity: 0.8!important;
}

.node-group.hover .node{
    stroke: #1F77B4!important;
    stroke-opacity: 0.7!important;
}

.heavily-connected {
    stroke: #000;
    stroke-width: 3px;
    stroke-opacity: 0.8;
}

.node-label {
    pointer-events: none;
}

.node-icon {
    pointer-events: none;
}

.link {
    stroke: #999;
}

.link-item {
}

.link-item:hover {
    stroke: black;
    stroke-width: 0.5px;
}

.link-item.selected {
    font-weight: 600;
}
.multilink {
    stroke-width: 3;
}
.link-border
{
    stroke: #fff;
    stroke-width:10px;
    stroke-opacity: 0;
    fill-opacity: 0;
}

.link-border:hover, .link-border.hover, .link-hover
{
    stroke: #1F77B4;
    stroke-opacity: 0.5;
}

.link-group.selected .link-border, .link-group.pre-selected .link-border
{
    stroke: #ed7225;
    stroke-opacity: 0.8;
}

.link-border.selected
{
    stroke: #ed7225;
    stroke-opacity: 0.8;
}

.link-label {
    pointer-events: none;
}

.hover-label
{
    fill: #aaa;
}

.hover-label-text
{
    fill: black;
}

.network-view-tool-window {
    position: absolute;
    background-color: white;
    display: none;
    z-index: 100;
    border: 1px solid #ccc;
}

.network-view-force-settings-window {
    min-width: 320px;
}

.network-view-global-container {
    width: 100%;
    height: 100%;
}

.network-view-zoom-buttons {
    position: absolute;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
}

.node-labels-header, .node-labels-content,
.rel-type-header, .rel-type-content {
    display: inline-block;
    margin-bottom: 10px;
}

.node-labels-header,
.rel-type-header {
    margin-right: 10px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
